import Vue from "vue";
import VueRouter from "vue-router";
import Page from "@/views/Page";
import Admin from "@/views/Admin";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/admin",
    name: "Admin",
    component: Admin,
    beforeEnter: async (to, from, next) => {
      // Wait for auth to initialize if it hasn't yet
      if (!store.getters.authInitialized) {
        await store.dispatch('initAuth');
      }

      if (store.getters.hasPrivilege) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: "/",
    name: "Search",
    component: Page,
  },
  // {
  //   path: "/opskrifter",
  //   name: "Categories",
  //   component: Page
  // },
  {
    path: "/:category",
    name: "Recipes",
    component: Page,
  },
  {
    path: "/opskrifter/:category",
    name: "Category",
    component: Page,
  },
  {
    path: "/opskrift/:url",
    name: "Recipe",
    component: Page,
  },

];

const router = new VueRouter({
  // When the user uses back/forward, the browser hands us the position they
  // were at. Restore it so the listing doesn't snap back to the top. We wait
  // a tick so the new route has had time to mount and the page is tall enough
  // to scroll into - otherwise the saved y can land beyond document.height.
  // Fresh navigations land at the top.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return new Promise(resolve => setTimeout(() => resolve(savedPosition), 50));
    }
    return { x: 0, y: 0 };
  },
  mode: "history",
  routes,
});

export default router;
